import React from "react";
import LegalPage from "@/components/LegalPage";
import usePageMeta from "@/lib/usePageMeta";

export default function Privatlivspolitik() {
  usePageMeta({
    title: "Privatlivspolitik",
    description:
      "Sådan behandler Hagelund ApS dine personoplysninger, når du kontakter os via hjemmesiden.",
  });

  return (
    <LegalPage
      testId="privacy-page"
      eyebrow="Juridisk"
      title="Privatlivspolitik"
      updated="August 2026"
      sections={[
        {
          number: "01",
          heading: "Dataansvarlig",
          body:
            "Hagelund ApS er dataansvarlig for behandlingen af de personoplysninger, som du afgiver på denne hjemmeside.\n\nHagelund ApS\nAugustvej 7, 2860 Søborg\nCVR-nr. 39651017\nTelefon: 22 56 14 15\nE-mail: ch@hagelund-aps.dk",
        },
        {
          number: "02",
          heading: "Hvilke oplysninger behandler vi?",
          body:
            "Når du udfylder kontaktformularen på hjemmesiden, indsamler og behandler vi følgende oplysninger om dig:",
          list: [
            "Navn",
            "Telefonnummer",
            "E-mailadresse",
            "Eventuelle oplysninger, du selv skriver i beskedfeltet",
            "Tidspunkt for din henvendelse samt hvilken side/kampagne, den kom fra",
          ],
        },
        {
          number: "03",
          heading: "Formål og retsgrundlag",
          body:
            "Vi behandler dine oplysninger for at kunne besvare din henvendelse, aftale et uforpligtende inspirationsmøde og eventuelt gennemføre et efterfølgende samarbejde.\n\nBehandlingen sker med hjemmel i databeskyttelsesforordningens artikel 6, stk. 1, litra b (foranstaltninger forud for en aftale) og artikel 6, stk. 1, litra f (legitim interesse i at kunne kontakte dig og drive vores virksomhed).",
        },
        {
          number: "04",
          heading: "Modtagere og databehandlere",
          body:
            "Dine oplysninger opbevares på servere hos vores driftsleverandører og videregives kun til betroede databehandlere, der hjælper os med driften af hjemmesiden og forsendelse af e-mails. Det omfatter blandt andet:",
          list: [
            "Vores hjemmeside- og hostingleverandør, som opbevarer data i EU/EØS",
            "Vores e-mailleverandør, som sender notifikationer om nye henvendelser",
          ],
        },
        {
          number: "05",
          heading: "Opbevaring",
          body:
            "Vi opbevarer dine oplysninger, så længe det er nødvendigt for at behandle din henvendelse og et eventuelt efterfølgende kundeforhold. Ubesvarede eller afsluttede henvendelser slettes senest 3 år efter seneste kontakt.\n\nOplysninger om gennemførte projekter kan opbevares længere med henblik på dokumentation, garanti og bogføring i overensstemmelse med gældende lovgivning.",
        },
        {
          number: "06",
          heading: "Dine rettigheder",
          body:
            "Du har som udgangspunkt følgende rettigheder efter databeskyttelsesreglerne:",
          list: [
            "Ret til indsigt i de oplysninger, vi behandler om dig",
            "Ret til berigtigelse af urigtige oplysninger",
            "Ret til sletning i visse tilfælde",
            "Ret til begrænsning af behandlingen",
            "Ret til indsigelse mod behandlingen",
            "Ret til dataportabilitet",
          ],
        },
        {
          heading: "Sådan gør du brug af dine rettigheder",
          body:
            "Kontakt os på ch@hagelund-aps.dk, hvis du ønsker at gøre brug af dine rettigheder. Vi svarer så hurtigt som muligt og senest inden for én måned.",
        },
        {
          number: "07",
          heading: "Klage til Datatilsynet",
          body:
            "Er du utilfreds med den måde, vi behandler dine personoplysninger på, kan du klage til Datatilsynet:\n\nDatatilsynet\nCarl Jacobsens Vej 35, 2500 Valby\ndt@datatilsynet.dk\nwww.datatilsynet.dk",
        },
      ]}
    />
  );
}
